<template>
  <div class="comp_exp_incidencias conflex pt-3"
       style="justify-content:center;background-color:#eee;min-width:700px">

     <!-- divido en dos columnas -->
    <!-- <div
      if="schema.ctrls.id.value !== ''"
        class="comp_exp_incidencias conflex "
        style=" justify-content:center;background-color: #eee;"

    > -->
      <!-- columnas  apd1 apd2 incidencias y debajo observaciones -->

      <div class="columna">
        <div class="conflex">

          <div class="columna">
            <div class="cab">APD 1 CHECKS</div>
            <v-sheet  v-bind="$cfg.styles.marco">
              <compfecha :schema="schema.ctrls.apd1_enc" :edicion="false" ></compfecha>
              <compfecha
                :schema="schema.ctrls.chkcom1"
                :edicion="is_edit && app==1 && record.fune1>0 && !record.chkcom1"
              ></compfecha>
              <compfecha
                :schema="schema.ctrls.chkcall1"
                :edicion="is_edit1 && !record.chkcall1"
              ></compfecha>
              <v-text-field
                v-bind="$input"
                v-model="schema.ctrls.chklugar1.value"
                :label="schema.ctrls.chklugar1.label"
                :disabled="!is_edit1"
              ></v-text-field>
              <ctrlgeo
                :schema="schema"
                name_ctrl="geo_fam1"
                :edicion="is_edit1"
              ></ctrlgeo>
              <ctrlgeo
                :schema="schema"
                name_ctrl="geo_iap1"
                :edicion="is_edit1"
              ></ctrlgeo>
              <compfecha
                :schema="schema.ctrls.chkfun1"
                :edicion="is_edit && app==1"
              ></compfecha>
              <compfecha
                :schema="schema.ctrls.chkterm1"
                :edicion="is_edit1 && record.fune1>0 && !record.chkterm1"
              ></compfecha>
            </v-sheet>
          </div>

          <div class="columna">
            <div class="cab">APD 2 CHECKS</div>
            <v-sheet v-bind="$cfg.styles.marco" >
              <compfecha :schema="schema.ctrls.apd2_enc" :edicion="false" ></compfecha>
              <compfecha
                :schema="schema.ctrls.chkcom2"
                :edicion="is_edit && app==1 && record.fune2>0 && !record.chkcom2"
              ></compfecha>
              <compfecha
                :schema="schema.ctrls.chkcall2"
                :edicion="is_edit2 && !record.chkcall2"
              ></compfecha>
              <v-text-field
                v-bind="$input"
                v-model="schema.ctrls.chklugar2.value"
                :label="schema.ctrls.chklugar2.label"
                :disabled="!is_edit2"
              ></v-text-field>
              <ctrlgeo
                :schema="schema"
                name_ctrl="geo_fam2"
                :edicion="is_edit2"
              ></ctrlgeo>
              <ctrlgeo
                :schema="schema"
                name_ctrl="geo_iap2"
                :edicion="is_edit2"
              ></ctrlgeo>
              <compfecha
                :schema="schema.ctrls.chkfun2"
                :edicion="is_edit && app==1"
              ></compfecha>
              <compfecha
                :schema="schema.ctrls.chkterm2"
                :edicion="is_edit2 && record.fune2>0 && !record.chkterm2"
              ></compfecha>
            </v-sheet>
          </div>

          <div class="columna">
            <div class="cab" style="display:flex; width:140px;">
              <div style="flex: 0 32px">?</div>
              <div style="text-align:center">INCIDENCIAS</div>
            </div>

            <div class="conflex">
              <!-- dos checks por fila-->
              <v-sheet v-bind="$cfg.styles.marco">
                <div style="flex: 1 1 auto">
                  <div style="display:flex">
                    <v-checkbox
                      v-bind="$checkbox"
                      v-model="schema.ctrls.chkocultacion_p.value"
                      :disabled="!is_edit"
                      :readonly="schema.ctrls.chkocultacion.value=='1'"
                      @change="incidencias('chkocultacion_p')"
                    />
                    <v-checkbox
                      v-bind="$checkbox"
                      v-model="schema.ctrls.chkocultacion.value"
                      :label="schema.ctrls.chkocultacion.label"
                      :disabled="!is_edit || !is_CosSup"
                      @change="incidencias('chkocultacion')"
                    />
                  </div>

                  <div style="display:flex">
                    <v-checkbox
                      v-bind="$checkbox"
                      v-model="schema.ctrls.chkreclamacion_p.value"
                      :disabled="!is_edit"
                      :readonly="schema.ctrls.chkreclamacion.value=='1'"
                      @change="incidencias('chkreclamacion_p')"
                    />
                    <v-checkbox
                      v-bind="$checkbox"
                      v-model="schema.ctrls.chkreclamacion.value"
                      :label="schema.ctrls.chkreclamacion.label"
                      :disabled="!is_edit || !is_CosSup"
                      @change="incidencias('chkreclamacion')"
                    />
                  </div>

                  <v-divider class="py-2"></v-divider>

                  <div style="display:flex;width:300px;">
                    <v-select
                      v-bind="$select"
                      v-model="schema.ctrls.renuncia.value"
                      :label="schema.ctrls.renuncia.label"
                      :items="motivosRenuncia"
                      :disabled="!is_edit"
                      item-value="id"
                      item-text="name"
                      @change="incidencias('renuncia')"
                    />

                  </div>

                  <div style="display:flex">

                    <v-checkbox
                      v-bind="$checkbox"
                      v-model="schema.ctrls.chkdevolucion.value"
                      :label="schema.ctrls.chkdevolucion.label"
                      :disabled="!is_edit"
                    ></v-checkbox>
                  </div>

                  <div style="display:flex">

                    <v-checkbox
                      v-bind="$checkbox"
                      v-model="schema.ctrls.chkbloq.value"
                      :label="schema.ctrls.chkbloq.label"
                      :disabled="!is_edit || !is_CosSup"
                      @change="incidencias('chkbloq')"
                    />
                  </div>

                  <v-divider class="pt-3 pb-2"></v-divider>

                  <div style="display:flex;width:300px;">
                    <v-select
                      v-bind="$select"
                      v-model="schema.ctrls.insufcapital.value"
                      :label="schema.ctrls.insufcapital.label"
                      :items="motivosInsuficiencia"
                      :disabled="!is_edit"
                      item-value="id"
                      item-text="name"
                      @change="incidencias('insufcapital')"
                    />
                  </div>

                   <div style="display:flex;width:300px;" v-if="schema.ctrls.insufcapital.value>'0'">
                    <v-select
                      v-bind="$select"
                      v-model="schema.ctrls.autoriza.value"
                      :label="schema.ctrls.autoriza.label"
                      :items="autorizadoCOS"
                      :disabled="!is_edit || !is_CosSup"
                      item-value="id"
                      item-text="name"
                      @change="incidencias('autoriza')"
                    />
                  </div>

                  <!--<autorizacion_CI
                      :ctrls="schema.ctrls"
                      :record="record"
                      :disabled="is_edit">
                    </autorizacion_CI> -->

                  </div>
              </v-sheet>
            </div>
          </div>
        </div>
        <!-- fin columnas flex APD1 APD2 INCIDENCIAS -->

        <div class="conflex">         
        </div>

        

      <!-- fin columnas flex APD1 APD2 INCIDENCIAS observaciones observaciones -->
      </div>
      <!-- fin division izquierda -->

       <!-- ----------------------------------------------------------------------------------------------------------------------->

      <!-- columna observaciones -->
      <div class="columna">

        <v-sheet v-bind="$cfg.styles.marco" style="width:500px;" >
          <ctrlobs3
            :schemaComponente="schema.ctrls.obs3_incidencias"
            :schema="schema"
            :record="record"
            :edicion="is_edit"
            agrupar
            motivos
          ></ctrlobs3>
        </v-sheet>

        <v-sheet v-bind="$cfg.styles.marco" >
          <ctrlobs3
            :schemaComponente="schema.ctrls.autoriza_obs"
            :schema="schema"
            :record="record"
            :edicion="is_edit && rol=='jz'">
          </ctrlobs3>
        </v-sheet>


        <!-- <div class="columna">
        <div class="cab">ULTIMOS CAMBIOS</div>
        <v-sheet v-bind="$cfg.styles.marco" style="height:100px;width:275px">
          <v-text-field
            v-bind="$input"
            v-model="schema.ctrls.op_last.value"
            label="CTD"
            :disabled="!is_edit"
          ></v-text-field>
          <v-text-field
            v-bind="$input"
            v-model="schema.ctrls.apd_last.value"
            label="APD"
            :disabled="!is_edit"
          ></v-text-field>
        </v-sheet>
        </div> -->

      </div>

      <!-- Dialog -->
      <v-dialog
        v-model="modal"
        content-class="modal"
        persistent>
          <div>
            <component
              :is="componente_dinamico"              
              :record="record"
              :ctrls="schema.ctrls"
              componenteTipo="FC"
              @close="closeModal"
              @cosSave="autorizaCosSave"
            />

    </div>
      </v-dialog>

  </div>
</template>

<script>

  import { mixinCtrls } from "@/mixins/mixinCtrls.js";
  import plugs from "@/common/general_plugs";
  const compfecha = () => plugs.groute("compfecha.vue", "comp");
  const ctrlobs3 = () => plugs.groute("ctrlobs3.vue", "comp");
  const ctrlgeo = () => plugs.groute("ctrlgeo.vue", "comp");
  const autorizacionCos = () => plugs.groute("autorizacionCos.vue", "comp");
  const exp_cierreApertura = () => plugs.groute("exp_cierreApertura.vue", "comp");


  export default {
    components: { compfecha, ctrlobs3, ctrlgeo, autorizacionCos, exp_cierreApertura },
    mixins: [mixinCtrls],
    props: {
      padre: { type:String, default: '' },
      componenteTipo: { type:String, default:'M' },
      Entorno: { type: Object, default: function() { return JSON.parse(JSON.stringify(this.$cfg.base.M)); }}
    },

    data() {
      return {
        schema:null,
        motivosInsuficiencia:[],
        motivosRenuncia:[],
        autorizadoCOS:[
          { id:"0", name:'PENDIENTE' },
          { id:"1", name:'AUTORIZADO' },
          { id:"2", name:'NO AUTORIZADO' }
        ],
        component_cierreApertura: null,
        cierreApertura_opcion:'',
        cierreAperturaId:'',

        componente_dinamico:null,
        modal:false,
      }
    },

    created(){
      this.ini_data();
    },

    methods:{

      ini_data() {

        // guardo del store en variables locales
        this.schema = this.$store.state[this.padre].schema;

        // items Insuficiencia Capital
        this.motivosInsuficiencia= this.$store.state.datos_iniciales.motivos_insufcapital;
        this.motivosInsuficiencia.unshift({ id:"0", name:'NO' });
        //
        this.motivosRenuncia= this.$store.state.datos_iniciales.motivos_renuncia;
        this.motivosRenuncia.unshift({ id:"0", name:'NO' });


      },

      
      changeReclamacion() {
      },

      ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

      // incidencias, confirma cambio de estado
      // renuncia
      // insufcapital
      // autoriza

      incidencias(evt) {
        let S= this.schema.ctrls;
        console.log('***incidencias', evt, S);

        // si autoriza, ventana con observaciones
        if (evt=='autoriza' && S.autoriza.value>'0') {
          //alert(`AUTORIZACION COS: ${this.autorizadoCOS.find(m=>m.id==S.autoriza.value).name}`);
          this.autorizaCos();
          return;
        }

       let eventos=[
          { accion:'', id:'chkocultacion_p', txt:'POSIBLE OCULTACION', pregunta:'', fnOk:'confirma', fnCancel:'cancela', obs:'chkocultacionobs', aviso:true, sms:false, incid:4 },
          { accion:'', id:'chkocultacion', txt:'OCULTACION', pregunta:'', fnOk:'confirma', fnCancel:'cancela', obs:'chkocultacionobs',  aviso:true, sms:true, incid:5 },
          { accion:'', id:'chkreclamacion_p', txt:'POSIBLE RECLAMACION', pregunta:'', fnOk:'confirma', fnCancel:'cancela', obs:'*', aviso:false, sms:true, incid:6 },
          { accion:'', id:'chkreclamacion', txt:'RECLAMACION', pregunta:'', fnOk:'confirma', fnCancel:'cancela', obs:'*', aviso:true, sms:false, incid:7 },
          { accion:'', id:'renuncia', txt:'RENUNCIA', pregunta:'', fnOk:'confirma', fnCancel:'cancela', obs:'*', aviso:true, sms:false, incid:8 },
          { accion:'', id:'chkbloq', txt:'BLOQUEO COS', pregunta:'', fnOk:'confirma', fnCancel:'cancela', obs:'*', aviso:true, sms:false, incid:3 },
          { accion:'', id:'insufcapital', txt:'CAPITAL INSUFICIENTE', pregunta:'', fnOk:'confirma', fnCancel:'cancela', obs:'autoriza_obs', aviso:false, sms:true, incid:9 },
          { accion:'', id:'autoriza', txt:'AUTORIZACION COS', pregunta:'', fnOk:'confirma', fnCancel:'cancela', obs:'autoriza_obs', aviso:true, sms:false, incid:10 },
          { accion:'', id:'fincompras', txt:'FIN DE COMPRAS', pregunta:'', fnOk:'confirma', fnCancel:'cancela', obs:'*', aviso:true, sms:false, incid:11 },
          { accion:'', id:'asispsico', txt:'ASISTENCIA PSICOLOGICA', pregunta:'', fnOk:'confirma', fnCancel:'cancela', obs:'*', aviso:true, sms:false, incid:12 },
          { accion:'', id:'gestoria', txt:'GESTORIA', pregunta:'', fnOk:'confirma', fnCancel:'cancela', obs:'*', aviso:true, sms:false, incid:13 },
          { accion:'', id:'iap', txt:'IAP', pregunta:'', fnOk:'confirma', fnCancel:'cancela', obs:'*', aviso:true, sms:false, incid:14 },
          { accion:'', id:'reapertura', txt:'REAPERTURA', pregunta:'', fnOk:'confirma', fnCancel:'cancela', obs:'chkdef', aviso:true, sms:false, incid:15 },
          { accion:'', id:'comunicado', txt:'COMUNICADO FUNERARIA', pregunta:'', fnOk:'confirma', fnCancel:'cancela', obs:'*', aviso:false, sms:false, incid:16 },
          { accion:'', id:'cierre', txt:'CIERRE EXPEDIENTE', pregunta:'', fnOk:'confirma', fnCancel:'cancela', obs:'chkdef', aviso:true, sms:false, incid:17 },
          { accion:'', id:'visado', txt:'VISADO FACTURAS', pregunta:'', fnOk:'confirma', fnCancel:'cancela', obs:'chkdef', aviso:true, sms:false, incid:18 },
          { accion:'', id:'envioMF', txt:'ENVIO MAPFRE', pregunta:'', fnOk:'confirma', fnCancel:'cancela', obs:'*', aviso:true, sms:false, incid:19 },

        ]
        let evento=eventos.find(e=>e.id==evt);

        if (!evento) {
          this.$root.$alert.open('Error No se ha definido el evento', 'error');
          return;
        }
        // si motivos, añadimos al final de txt
        if (evt=='renuncia' && S.renuncia.value>'0') evento.txt+=`: ${this.motivosRenuncia.find(m=>m.id==S.renuncia.value).name}`;
        if (evt=='insufcapital' && S.insufcapital.value>'0') evento.txt+=`: ${this.motivosInsuficiencia.find(m=>m.id==S.insufcapital.value).name}`;
        
        // emitimos evento
        evento.accion=(!evento.accion?'confirmar_incidencia':(evento.accion=='no'?'no_incidencia':evento.accion));
        this.$emit('onEvent', evento);
      },

      // cerramos modal
      closeModal() {
        this.modal=false;
        this.componente_dinamico=null;
      },

      // Modal Autorizacion
      autorizaCos() {
        this.componente_dinamico= "autorizacionCos";
        this.disparo= !this.disparo;
        this.modal=true;
      },

      // guardamos y cerramos modal
      autorizaCosSave(evt) {
        console.log('***autorizaCosSave', evt);
        let S= this.schema.ctrls;

        let txt= 'CAPITAL INSUFICIENTE COS ' + (S.autoriza.value=='2'? 'NO ' : '') + 'AUTORIZA: ' + evt.schema.ctrls.txt.value;
        let evento= { accion:'confirma', id:'autoriza', txt,  obs:'autoriza_obs', aviso:true, sms:false, incid:10 };
        this.$emit('onEvent', evento);    

        this.closeModal();
      },

      refresh() {
        this.$emit('onEvent',{accion: 0});
      },
      
    },


    computed: {
      record: function() { return this.$store.state[this.padre].record; },

      // devuelvo si estamos en modo edición en el Mto
      is_edit() {
        return this.$store.state[this.padre].estado === "editar" || this.$store.state[this.padre].estado === "nuevo"? true : false;
      },

      is_edit1() {
        return this.is_edit && this.record.apd1>0 && (this.app==1||this.rol=='jz'||(this.rol=='apds' && this.rolId==this.record.apd1))
      },

      is_edit2() {
        //console.log('***** **** **** exp_m_incidencias.is_edit2', this.app,this.rol,this.rolId,this.schema.ctrls,this.elem);
        return this.is_edit && this.record.apd2>0 && (this.app==1||this.rol=='jz'||(this.rol=='apds' && this.rolId==this.record.apd2))
      },

      is_CosSup() {
        //return (this.app==1 && this.ndep>= 6) || this.rol=='jz';
        return (this.app==1 && this.ndep>=6) || (this.app==2 && this.ndep>=2);
      },

      get_motivos() {
        return this.$store.state.datos_iniciales.motivos_prefam;
      }
    }
  }

</script>
